import { Injectable } from '@angular/core';
import { paths } from '@core/typings/dc-backend-definitions';
import { environment } from '@env/environment';
import { Fetcher, Middleware } from 'openapi-typescript-fetch';

@Injectable({
    providedIn: 'root',
})
export class FetcherService {
    public fetcher = Fetcher.for<paths>();

    constructor() {
        this.initFetcher(null);
    }

    public initFetcher(accessToken: string | null): void {
        const headerMiddleWare: Middleware = async (url, init, next) => {
            // Set the Bearer Token
            if (accessToken !== null || accessToken !== '') {
                init.headers.append('Authorization', 'Bearer ' + accessToken);
            }

            const response = await next(url, init);
            return response;
        };

        this.fetcher.configure({
            baseUrl: environment.apiUrl,
            use: [headerMiddleWare],
        });
    }
}
